import { Component, OnInit } from '@angular/core';
import { ErrorHandler } from '../../../shared/services/error-handler.service';

@Component({
  selector: 'app-reset-password-section',
  templateUrl: './reset-password-section.component.html',
  styleUrls: ['./reset-password-section.component.scss'],
  providers: [ErrorHandler]
})
export class ResetPasswordSectionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
